/*
  {% render 'product-quantity-selector', product: product %}
*/

import formatMoney from '../utils/formatMoney';
import updateQuantityButtonStates from '../utils/updateQuantityButtonStates';

const initQuantityInputs = (container = document.querySelector('[data-product-main]')) => {
  const quantitySelectors = container.querySelectorAll('[data-quantity-selector]');

  if (!quantitySelectors.length) return;

  const updateAtcBtnPrice = (selector, qty) => {
    const form = selector.querySelector('input').form;
    const atcButton = form.querySelector('button[type="submit"]');
    const newPrice = formatMoney(Number(selector.dataset.qtySelectorVariantPrice * qty));
  };

  const changeInput = (qtyInput, value, selector) => {
    if (qtyInput.checkValidity()) {
      const max = qtyInput.max ? +qtyInput.max : Infinity;
      const inputValue = +qtyInput.value;
      const newValue = Math.min(inputValue + value, max);
      qtyInput.value = String(newValue);
      updateAtcBtnPrice(selector, newValue);
      updateQuantityButtonStates(selector);
    }
  };

  quantitySelectors.forEach(selector => {
    const qtyInput = selector.querySelector('[data-quantity-input]');

    if (!qtyInput.disabled) updateQuantityButtonStates(selector);

    qtyInput.addEventListener('change', () => changeInput(qtyInput, 0, selector));
    selector.addEventListener('click', (evt) => {
      const decBtn = evt.target.closest('[data-quantity-dec]');
      const incBtn = evt.target.closest('[data-quantity-inc]');
      decBtn && +qtyInput.value > 1 ? changeInput(qtyInput, -1, selector) : null;
      incBtn ? changeInput(qtyInput, +1, selector) : null;
    });
  });
};

export default initQuantityInputs;
